import { render, staticRenderFns } from "./PopupPreview.vue?vue&type=template&id=045dd5ff&scoped=true&lang=pug&"
import script from "./PopupPreview.vue?vue&type=script&lang=coffee&"
export * from "./PopupPreview.vue?vue&type=script&lang=coffee&"
import style0 from "./PopupPreview.vue?vue&type=style&index=0&id=045dd5ff&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045dd5ff",
  null
  
)

export default component.exports